import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap5';

import routes from 'app/routes';
import usePolicyTemplates from 'components/Common/PolicyTemplates/Hooks/usePolicyTemplates';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import CalculatorPlans from 'components/Affiliates/Onboarding/CalculatorPlans';

export default function Index() {
  const { templates } = usePolicyTemplates();

  return (
    <div className="content">
      <section>
        <Row>
          <Col>
            <h1>Talent Insurance Calculator</h1>
          </Col>

          <Col md="auto">
            <Link
              to={routes.affiliates.prospects.index}
              className="btn btn-primary mt-3 mt-md-0"
            >
              Prospects List
            </Link>
          </Col>
        </Row>
      </section>

      <section>
        {templates == null
          ? <LoadingPlaceholder text="Loading..." />
          : (
            <CalculatorPlans
              templates={templates.filter((item) => item.attributes.title !== 'TI Enterprise')}
            />
          )}
      </section>
    </div>
  );
}
